module.exports = "/assets/data/aa05a158eac36cbc1745128e9e4be893-GU35.data.json";